import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import useAuth from 'src/hooks/useAuth';

const AvatarComponent = () => {
  const { user } = useAuth();
  const [image, setImage] = useState(
    JSON.parse(localStorage.getItem('user_img_perfil')),
  );
  useEffect(() => {
    /*  localStorage.setItem(
      'user_img_perfil',
      JSON.stringify(user.user_img_perfil),
    ); */
    setImage(JSON.stringify(user.user_img_perfil));
  }, [user]);
  return (
    <>
      {JSON.parse(localStorage.getItem('user_img_perfil')) ? (
        <Avatar
          alt="Remy Sharp"
          src={`data:image/png;base64,${JSON.parse(
            localStorage.getItem('user_img_perfil'),
          )}`}
        />
      ) : user.user_img_perfil ? (
        <Avatar
          alt="foto"
          src={`data:image/png;base64,${user.user_img_perfil}`}
        />
      ) : (
        <Avatar>{user.user_nombre[0].toUpperCase()}</Avatar>
      )}
    </>
  );
};

export default AvatarComponent;
